module.exports = __webpack_public_path__ + "img/2.57753075.png";